import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';
import { Focusable } from 'components/navigation';

export const StyledHeader = styled.div`
  position: absolute;
  width: 100%;
  height: ${scaleSize(72)}px;
  left: ${scaleSize(220)}px;
  top: ${scaleSize(50)}px;

  font-family: RobotoMedium;
  font-style: normal;
  font-weight: 500;
  font-size: ${scaleSize(48)}px;
  line-height: ${scaleSize(72)}px;
  letter-spacing: -0.333333px;
  color: ${({ theme }) => theme.activeColorText};
`;

export const StyledContentWrapper = styled.div`
  position: relative;
  top: ${scaleSize(280)}px;
  left: ${scaleSize(180)}px;
  white-space: nowrap;
`;

export const StyledTariffItem = styled(Focusable)`
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  width: ${scaleSize(355)}px;
  height: ${scaleSize(512)}px;
  margin-right: ${({ isSubscriptionItem }) => scaleSize(isSubscriptionItem ? 81 : 20)}px;
  background-color: ${({ theme }) => theme.imagePlaceholder};
  border-radius: ${scaleSize(12)}px;
  white-space: normal;

  &:focus {
    background-color: ${({ theme }) => theme.activeColor};
    transform: translate3d(0, -${scaleSize(10)}px, 0);
  }

  &:after {
    content: '';
    display: ${({ isSubscriptionItem }) => (isSubscriptionItem ? 'block' : 'none')};
    position: absolute;
    width: 1px;
    height: ${scaleSize(512)}px;
    top: 0;
    left ${scaleSize(395)}px;
    background-color: ${({ theme }) => theme.devider};
  }
`;

export const TariffItemTitle = styled.div`
  position: absolute;
  top: ${scaleSize(100)}px;
  width: 100%;
  font-family: 'RobotoCondensedBold';
  font-style: normal;
  font-weight: bold;
  font-size: ${scaleSize(40)}px;
  line-height: ${scaleSize(56)}px;
  text-align: center;
  letter-spacing: -0.277778px;
  color: ${({ theme }) => theme.mainTextColor};

  ${StyledTariffItem}:focus & {
    color: ${({ theme }) => theme.defaultColor};
  }
`;

export const TariffItemPromoLabel = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  width: ${scaleSize(111)}px;
  height: ${scaleSize(48)}px;
  top: ${scaleSize(166)}px;
  font-family: RobotoMedium, sans-sefir;
  font-size: ${scaleSize(24)}px;
  line-height: ${scaleSize(44)}px;
  text-align: center;
  color: ${({ theme }) => theme.defaultColor};
  background-color: ${({ theme }) => theme.activeColor};
  border-radius: ${scaleSize(10)}px;

  ${StyledTariffItem}:focus & {
    color: ${({ theme }) => theme.activeColor};
    background-color: ${({ theme }) => theme.defaultColor};
  }
`;

export const TariffItemPrice = styled.div`
  position: absolute;
  width: 100%;
  height: ${scaleSize(48)}px;
  top: ${scaleSize(341)}px;
  text-align: center;
  font-family: RobotoMedium, sans-sefir;
  font-style: normal;
  font-weight: 500;
  font-size: ${scaleSize(34)}px;
  line-height: ${scaleSize(48)}px;
  color: ${({ theme }) => theme.mainTextColor};

  ${StyledTariffItem}:focus & {
    color: ${({ theme }) => theme.defaultColor};
  }
`;

export const TariffItemDuration = styled.div`
  position: absolute;
  top: ${scaleSize(404)}px;
  width: 100%;
  height: ${scaleSize(28)}px;

  font-family: RobotoMedium, sans-sefir;
  font-style: normal;
  font-weight: 500;
  font-size: ${scaleSize(24)}px;
  line-height: ${scaleSize(28)}px;

  text-align: center;
  letter-spacing: -0.166667px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.secondaryTextColor};

  ${StyledTariffItem}:focus & {
    color: ${({ theme }) => theme.defaultColor};
  }
`;
